module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEASURBVHgB7ZdRCoQwDAXDXlxvoDfQm2bLroXn0i3VJmmEzKcfyQxoi0RBEARBUIGZJ/6ykBFp13bsnKgXPrORMiD/gXpJM3ariF/5xEoSWEQU5HeSRDNCXR4WiUeYycNCsQhzeVjcHTFMHgRuRwyXB5HLEW7kQag5wp18piXCrXymFuFePlOKeIx8phDxHPnMn4idFHiRDtz4zB+Fd774Ybuk9MGy4f9EF7XTxn0ENxyVbiP4wjnvLoJvXFJuIrjjhh0e0SMPM8ZESMjDLNsISXmYaROhIQ+zdSM05WGHTkQatGjLwy75CCt52HeKoF7SjNlKHnaux86ZgiAIgqDCG7F+Wm8t9z5sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_close_black.png
// module id = G75f
// module chunks = 0